import { useEffect, useRef } from "react";

export function useCurrencyReplacer(targetRef) {
  const observerRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const replaceText = () => {
      const elements = document.body.querySelectorAll(
        "*:not(script):not(style):not(.icon-NewSaudiCurrency)",
      );

      elements.forEach((element) => {
        const walkNodes = (node) => {
          if (
            node.tagName?.toLowerCase() !== "script" &&

            node.nodeType === Node.TEXT_NODE &&
            !node.parentElement?.closest(".icon-NewSaudiCurrency")
          ) {
            const text = node.textContent;
            if (
              text?.includes("ريال") ||
              text?.includes("ريال سعودي") ||
              text?.includes("بالريال")
            ) {
              const span = document.createElement("span");
              span.innerHTML = text.replace(
                /(بالريال|ريال سعودي|ريال)/g,
                '<span class="icon-NewSaudiCurrency"></span>',
              );
              node.parentNode.replaceChild(span, node);
            }
          }
          node.childNodes.forEach(walkNodes);
        };

        walkNodes(element);
      });
    };

    observerRef.current = new MutationObserver(replaceText);

    const targetElement = targetRef || document.body;
    observerRef.current.observe(targetElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    replaceText();

    return () => {
      observerRef.current?.disconnect();
    };
  }, [targetRef]);
}
